import { type ReviewCycleRefreshFilter, ReviewCycleRefreshFilterSchema } from "./components/ReviewCyclesFiltersRefresh";

import type { GetReviewCyclesParams } from "../../../../../api/services/defs/internal-api/review-cycles";

/** What the `filters` query param can hold: the current shape, or a link predating the refresh. */
type StoredReviewCycleFilters = {
	type?: string[];
	status?: string[] | string;
	reviews360?: string[];
	automation_status?: string;
};

/** The query param is unvalidated JSON, so anything not matching the current shape is dropped. */
export const normalizeReviewCycleFilters = (filters?: StoredReviewCycleFilters): ReviewCycleRefreshFilter => {
	const parsed = ReviewCycleRefreshFilterSchema.safeParse(filters ?? {});
	return parsed.success ? parsed.data : {};
};

type ReviewCycleQueryParams = Partial<Pick<GetReviewCyclesParams, "search" | "status" | "type" | "easyAddEnabled">>;

export const getQueryParamsFromFilters = (
	filters: ReviewCycleRefreshFilter,
	searchTerm?: string
): ReviewCycleQueryParams => {
	const params: ReviewCycleQueryParams = {};

	if (filters.type?.length) {
		params.type = filters.type;
	}

	if (filters.status?.length) {
		params.status = filters.status;
	}

	if (filters.reviews360?.length) {
		params.easyAddEnabled = true;
	}

	if (searchTerm) {
		params.search = searchTerm;
	}

	return params;
};

const SORTABLE_FIELDS = ["name", "type", "createdAt", "startDate", "status"];

/** Links from the legacy page sort by the search service's field name. */
const LEGACY_SORT_ALIASES: Record<string, string> = { start_date: "startDate" };

export const mapSortField = (field: string): string => {
	const resolved = LEGACY_SORT_ALIASES[field] ?? field;
	return SORTABLE_FIELDS.includes(resolved) ? resolved : "createdAt";
};
